import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import Index from "@/pages/Index";
import { optimizedSrc, buildSrcSet } from "@/components/OptimizedImage";
import { getHomeContent } from "@/lib/home-content.functions";

export const Route = createFileRoute("/")({
  loader: async () => getHomeContent(),
  head: ({ loaderData }) => {
    const head = routeHead({
      path: '/',
      title: "JIIA Studio · Architecte d'intérieur & Designer de concept",
      description: "Architecte d'intérieur & spécialiste couleur. Concept, mobilier sur mesure, identité forte. Les espaces dont on se souvient, à Lyon et en Rhône-Alpes.",
    });
    const hero = loaderData?.heroImage;
    if (hero) {
      head.links.push({
        rel: "preload",
        as: "image",
        href: optimizedSrc(hero, 1280),
        imagesrcset: buildSrcSet(hero, 1280) ?? "",
        imagesizes: "100vw",
        fetchpriority: "high",
      });
    }
    return head;
  },
  component: Index,
});
